import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPushPathWrapper } from '../../../routes';
import EditorialWorkflowDrawer from './EditorialWorkflowDrawer'; // 👈 Import the clean drawer

class EditorialWorkflow extends Component {
  state = {
    drawerVisible: false,
  };

  showDrawer = (e) => {
    e.preventDefault();
    this.setState({ drawerVisible: true });
  };

  closeDrawer = () => {
    this.setState({ drawerVisible: false });
  };

  render() {
    const { data, dispatch } = this.props;
    const workflow = (data && data.workflow) ? data.workflow : {};

    const workflowStages = [
      { key: 'submittedArticle',  title: 'Submitted Manuscript',    sub: 'New submissions received',        color: '#52c41a',  count: workflow.submittedArticle  || 0, routeKey: 'article.submittedArticles' },
      { key: 'underProcess',      title: 'Under Process',           sub: 'Payment and processing stage',    color: '#1890ff',  count: workflow.underProcess      || 0, routeKey: 'article.underProcess' },
      { key: 'underReviewer',     title: 'Under Review',            sub: 'Reviewer invitation pending',     color: '#722ed1',  count: workflow.underReviewer     || 0, routeKey: 'article.underReviewer' },
      { key: 'reviewedComments',  title: 'Reviewed Manuscript',     sub: 'Reports currently awaited',       color: '#13c2c2',  count: workflow.reviewedComments  || 0, routeKey: 'article.reviewedArticles' },
      { key: 'commentsToAuthor',  title: 'Comments To Author',      sub: 'Feedback sent to author',         color: '#fa8c16',  count: workflow.commentsToAuthor  || 0, routeKey: 'article.commentsToAuthor' },
      { key: 'revisedArticle',    title: 'Revised Manuscript',      sub: 'Revision deadline active',        color: '#ff7a45',  count: workflow.revisedArticle    || 0, routeKey: 'article.revisedArticle' },
      { key: 'approvedArticle',   title: 'Approved',                sub: 'Approved for publication',        color: '#36cfc9',  count: workflow.approvedArticle   || 0, routeKey: 'article.approvedArticle' },
      { key: 'acceptedArticle',   title: 'Accepted',                sub: 'Accepted — payment pending',      color: '#40a9ff',  count: workflow.acceptedArticle   || 0, routeKey: 'article.acceptedArticles' },
      { key: 'composingArticle',  title: 'Under Composing',         sub: 'Typesetting in progress',         color: '#eb2f96',  count: workflow.composingArticle  || 0, routeKey: 'article.composingArticle' },
      { key: 'galleyProof',       title: 'Galley Proof / Reprints', sub: 'Author proof review',             color: '#faad14',  count: workflow.galleyProof       || 0, routeKey: 'article.galleyProof' },
      { key: 'doi',               title: 'DOI Generation',          sub: 'DOI processing queue',            color: '#9254de',  count: workflow.doi               || 0, routeKey: 'article.DOIArticle' },
      { key: 'onlinePublish',     title: 'Online Published',        sub: 'Live on portal',                  color: '#2f8f65',  count: workflow.onlinePublish     || 0, routeKey: 'article.OnlinePublishArticle' },
      { key: 'publishedArticle',  title: 'Published Article',       sub: 'Print publication sent',          color: '#389e0d',  count: workflow.publishedArticle  || 0, routeKey: 'article.CompletePublication' },
    ];

    return (
      <div className="adminCard workflowCard">
        <div className="adminCardHeader">
          <div className="adminCardTitleBlock">
            <div className="adminCardTitle">Editorial Workflow</div>
            <div className="adminCardSubtitle">Current queue by manuscript stage</div>
          </div>
          <a href="#" className="adminCardAction" onClick={this.showDrawer}>Manage &rarr;</a>
        </div>

        <div className="cardDivider"></div>

        <div className="workflowList">
          {workflowStages.map((stage) => (
            <div
              className="workflowItem"
              key={stage.key}
              style={{ cursor: 'pointer' }}
              onClick={() => dispatch(getPushPathWrapper(stage.routeKey))}
            >
              <span className="workflowDot" style={{ backgroundColor: stage.color }}></span>
              <div className="workflowText">
                <div className="workflowTitle">{stage.title}</div>
                <div className="workflowSub">{stage.sub}</div>
              </div>
              <div className="workflowCount">{stage.count}</div>
            </div>
          ))}
        </div>

        {this.state.drawerVisible && (
          <EditorialWorkflowDrawer
            visible={this.state.drawerVisible}
            onClose={this.closeDrawer}
          />
        )}
      </div>
    );
  }
}

export default connect()(EditorialWorkflow);